<!--
 * @Author: your name
 * @Date: 2021-05-27 17:16:12
 * @LastEditTime: 2021-09-23 13:41:23
 * @LastEditors: fangshengchu
 * @Description: In User Settings Edit
 * @FilePath: \plantmate-shopping\src\App.vue
-->
<template>
  <div>
    <transition name="el-fade-in-linear">
      <router-view :class="$i18n.locale" />
    </transition>
    <!-- 全局弹窗 -->
    <AuthCompany ref="authCompanyRef" @comfirm="authCompanyHandle" />
    <LoginDialog></LoginDialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import AuthCompany from "@/components/authCompany/index.vue";
import {
  USER_AUTH_COMPANY_MODAL,
  USER_AUTH_COMPANY_MODAL_COMFIRM,
} from "./components/authCompany/helper";
import LoginDialog from "./views/pages/loginDialog.vue";

export default {
  components: {
    AuthCompany,
    LoginDialog
  },
  watch: {
    "$i18n.locale": "i18nHandle",
  },
  created() {
    this.i18nHandle(this.$i18n.locale);
    if (!this.bus._events["refushUserInfo"]) {
      this.bus.$on("refushUserInfo", () => {
        this.getUserInfo();
      });
    }
    console.log("test");
    if (!this.bus._events["getUserMenuPerm"]) {
      this.bus.$on("getUserMenuPerm", () => {
        this.getMenu();
      });
    }
    const grayScreen = 2; // 生效状态码
    this.$http
      .get("/help/sysColorManagement/getColorByAppId?sysAppId=1001")
      .then(({ data: { code, data } }) => {
        if (+code === 0 && data && +data.status === grayScreen) {
          document.documentElement.style = "filter: grayscale(1);";
        } else {
          document.documentElement.style = "";
        }
      });
    this.initBus();
  },
  methods: {
    initBus() {
      console.log('initBus');
      this.bus.$on(USER_AUTH_COMPANY_MODAL, (tip) => {
        console.log('initBus USER_AUTH_COMPANY_MODAL');
        
        this.$refs.authCompanyRef.onShow(tip);
      });
    },
    authCompanyHandle(...res) {
      this.$router.go(0); //刷新当前页面
      this.bus.$emit(USER_AUTH_COMPANY_MODAL_COMFIRM, ...res);
    },
    i18nHandle(val, oldVal) {
      Cookies.set("language", val);
      // document.querySelector('html').setAttribute('lang', val)
      // // document.title = messages[val].brand.lg
      // // 非登录页面，切换语言刷新页面
      // if (this.$route.name !== 'login' && oldVal) {
      //   window.location.reload()
      // }
    },
    // 获取当前管理员信息
    getUserInfo() {
      return this.$http
        .get("/front/consumer/usercenter/custUserCenterInfo", {
          params: {
            appCode: "PLANTMATE_OFFICIAL",
            companyId: this.$store.state.user.defaultCompanyId + "" || "",
          },
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          // this.$store.state.cardInfo = res.data.cardInfo
          this.$store.dispatch("companyList", res.data.companyAccountInfo || []);
          this.$store.dispatch("setUserInfo", res.data.userInfo);
          Cookies.set("userId", res.data.userInfo.userId);
          Cookies.set("mobile", res.data.userInfo.mobile);
          // this.$store.state.user.username = res.data.userInfo.username
          // this.$store.state.user.name = res.data.userInfo.name
          // this.$store.state.user.mobile = res.data.userInfo.mobile
          // this.$store.state.user.email = res.data.userInfo.email
        })
        .catch(() => {});
    },
    // 获取当前登录用户权限 及个人中心菜单
    getMenu() {
      window.SITE_CONFIG["menuList"] = [];
      this.$store.commit("setMenuList", []);
      this.$http
        .get(`/front/consumer/menu/bar/${window.SITE_CONFIG["appCode"]}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          window.SITE_CONFIG["menuList"] = res.data.tree;
          console.warn(res.data.tree);
          this.$store.commit("setMenuList", res.data.tree);
          window.SITE_CONFIG["permissions"] = res.data.api;
          // window.SITE_CONFIG['permissions'] = res.data.permissions || []
        })
        .catch(() => {});
    },
  },
  beforeDestroy() {
    this.bus.$off();
  },
};
</script>
